import { forwardRef } from 'react';

import { Props } from './types';
import { StyledPaper } from './Paper.styled';

export const Paper = forwardRef<HTMLDivElement, Props>(
  ({ elevationType, className, ...props }: Props, ref) => {
    let elevationClass;
    switch (elevationType) {
      case 'dropdown':
        elevationClass = 'dropdown';
        break;
      case 'smallDialog':
        elevationClass = 'smallDialog';
        break;
      case 'interaction':
        elevationClass = 'interaction';
        break;
      case 'modalOnOverlay':
        elevationClass = 'modalOnOverlay';
        break;
      case 'modalOnWhite':
        elevationClass = 'modalOnWhite';
        break;
      case 'callPopWidget':
        elevationClass = 'callPopWidget';
        break;
      default:
        elevationClass = '';
    }
    const paperClassName = [elevationClass, className].filter(Boolean).join(' ');
    return <StyledPaper className={paperClassName} ref={ref} {...props} />;
  },
);
Paper.displayName = 'Paper';
